import React from 'react';
import { useTranslation } from 'react-i18next';


function HelpContent({ setShowHelp, page }) {
  const { t } = useTranslation();
  return (
        <div className="help-text-wrapper">
        <div className="help-text-container">
          <p className="help-text">
            {page === 'game_overview' && t("help.game_overview")}
            {page === 'question_overview' && t("help.question_overview")}
            {page === 'main_question' && t("help.main_question")}
            {page === 'mix_n_match' && t("help.mix_n_match")}
            {page === 'swipe' && t("help.swipe")}
          </p>
          <button className="button help-button" onClick={e => { setShowHelp(false) }}>Close</button>
        </div>
      </div>
  )
}

export default HelpContent;